import './content-wrapper.css';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Jurisdictions } from '../interfaces/EntityDraftViewModel';

const jurisdictionsSuffixCodeMap = {
  'United States': '', // default empty key
  'United Kingdom': 'UK'
};

interface ContentWrapperProps {
  children?: any;
  type: 'field' | 'category' | 'page';
  contentKey: string;
  dynamicProps: any;
  dynamicJurisdictions: Jurisdictions[];
  label?: any;
}

const ContentWrapper: React.FC<ContentWrapperProps> = ({ type, contentKey, dynamicProps, dynamicJurisdictions, label, children }) => {
  if (!contentKey) {
    return <>{label}{children}</>;
  }

  return (
    <>
      <Content type={type} contentKey={contentKey + 'Before'} dynamicProps={dynamicProps} dynamicJurisdictions={dynamicJurisdictions} />
      {label}
      <Content type={type} contentKey={contentKey} dynamicProps={dynamicProps} dynamicJurisdictions={dynamicJurisdictions} />
      {children}
      <Content type={type} contentKey={contentKey + 'After'} dynamicProps={dynamicProps} dynamicJurisdictions={dynamicJurisdictions} />
    </>
  );
};

type ContentProps = ContentWrapperProps

const Content: React.FC<ContentProps> = ({ type, contentKey, dynamicProps, dynamicJurisdictions }) => {
  const { t } = useTranslation(`${type}-level-content`, { useSuspense: false });
  const contentKeySuffix = dynamicJurisdictions.map(jurisdiction => jurisdictionsSuffixCodeMap[jurisdiction.jurisdiction]).find(jurisdictionName => !!jurisdictionName) || '';
  const contentKeyWithJurisdiction = contentKey + contentKeySuffix;
  const content = t(contentKeyWithJurisdiction, dynamicProps);

  return (
    <>
      {content && content !== contentKeyWithJurisdiction && <div className="content-wrapper" dangerouslySetInnerHTML={{ __html: content }} />}
      {content && content === contentKeyWithJurisdiction && contentKey !== contentKeyWithJurisdiction && <Content type={type} contentKey={contentKey} dynamicProps={dynamicProps} dynamicJurisdictions={[]} />}
    </>
  );
};

export default ContentWrapper;
